import { render, staticRenderFns } from "./IcoSurveyContent.vue?vue&type=template&id=f383d59a"
import script from "./IcoSurveyContent.vue?vue&type=script&lang=js"
export * from "./IcoSurveyContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports